
import React from "react";

const BoatOnOcean = () => {
    return (
        <div style={{
            width: "100%",
            minHeight: "480px",
            overflow: "hidden",
            position: "relative",
            borderRadius: "20px",
            background: "linear-gradient(180deg,#91d5f5 0%,#d3efff 35%,#087db5 70%,#003b70 100%)",
            fontFamily: "sans-serif",
            marginBottom: "1rem",
            isolation: "isolate"
        }}>

            <style>{`
                @keyframes shipSail {
                    0%,100% { transform: translateY(0) rotate(-2deg); }
                    25% { transform: translateY(-12px) rotate(2deg); }
                    50% { transform: translateY(5px) rotate(-1deg); }
                    75% { transform: translateY(-8px) rotate(3deg); }
                }

                @keyframes waveOne {
                    0%,100% { transform: translateX(0) translateY(0); }
                    50% { transform: translateX(2%) translateY(7px); }
                }

                @keyframes waveTwo {
                    0%,100% { transform: translateX(0); }
                    50% { transform: translateX(-2%); }
                }

                @keyframes sparkle {
                    0%,100% { opacity:.2; transform:scale(.7); }
                    50% { opacity:1; transform:scale(1.3); }
                }

                @keyframes cloudMove {
                    from { transform:translateX(-30px); }
                    to { transform:translateX(40px); }
                }

                @keyframes foam {
                    0% { transform:translateX(-20px); opacity:.3; }
                    50% { opacity:.9; }
                    100% { transform:translateX(20px); opacity:.3; }
                }
            `}</style>

            {/* 제목 */}
            <h1 style={{
                position: "relative",
                zIndex: 10,
                textAlign: "center",
                paddingTop: "22px",
                margin: 0,
                color: "#16456a",
                fontSize: "clamp(24px,4vw,34px)",
                fontWeight: 900,
                letterSpacing: "-1.5px",
                textShadow: "0 2px 5px #ffffff"
            }}>
                나만의 항해일지
            </h1>

            {/* 구름 */}
            <div style={{
                position: "absolute",
                top: "75px",
                left: "10%",
                fontSize: "45px",
                opacity: .65,
                animation: "cloudMove 8s ease-in-out infinite alternate"
            }}>
                ☁️
            </div>

            <div style={{
                position: "absolute",
                top: "105px",
                right: "12%",
                fontSize: "35px",
                opacity: .55,
                animation: "cloudMove 10s ease-in-out infinite alternate-reverse"
            }}>
                ☁️
            </div>

            {/* 햇빛 */}
            <div style={{
                position: "absolute",
                top: "60px",
                right: "20%",
                width: "65px",
                height: "65px",
                borderRadius: "50%",
                background: "#fff3b0",
                boxShadow: "0 0 55px 20px rgba(255,230,130,.5)"
            }}/>

            {/* 배 */}
            <div style={{
                position: "absolute",
                zIndex: 5,
                top: "100px",
                left: 0,
                width: "100%",
                display: "flex",
                justifyContent: "center",
                animation: "shipSail 4s ease-in-out infinite"
            }}>
                <svg
                    viewBox="0 0 400 300"
                    style={{
                        width: "min(75%,400px)",
                        overflow: "visible",
                        filter: "drop-shadow(0 14px 9px rgba(0,30,60,.25))"
                    }}
                >
                    <defs>
                        <linearGradient id="wood" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="0%" stopColor="#b77b49"/>
                            <stop offset="100%" stopColor="#59331f"/>
                        </linearGradient>

                        <linearGradient id="whiteSail" x1="0" y1="0" x2="1" y2="1">
                            <stop offset="0%" stopColor="#ffffff"/>
                            <stop offset="100%" stopColor="#b8d4e8"/>
                        </linearGradient>
                    </defs>

                    {/* 돛대 */}
                    <path
                        d="M200 20 L200 230"
                        stroke="#503322"
                        strokeWidth="9"
                    />

                    {/* 왼쪽 큰 돛 */}
                    <path
                        d="M190 35 L75 190 L190 190 Z"
                        fill="url(#whiteSail)"
                        stroke="#40576b"
                        strokeWidth="3"
                    />

                    {/* 오른쪽 돛 */}
                    <path
                        d="M210 50 L325 180 L210 180 Z"
                        fill="#f5f8ff"
                        stroke="#40576b"
                        strokeWidth="3"
                    />

                    {/* 돛 주름 */}
                    <path
                        d="M180 65 L120 165 M220 75 L285 160"
                        stroke="#c4d3df"
                        strokeWidth="2"
                        fill="none"
                    />

                    {/* 깃발 */}
                    <path
                        d="M200 20 L250 35 L200 48 Z"
                        fill="#ff6464"
                    />

                    {/* 갑판 */}
                    <path
                        d="M85 190 L320 180 L290 205 L115 210 Z"
                        fill="#d49a62"
                        stroke="#503322"
                        strokeWidth="3"
                    />

                    {/* 선체 */}
                    <path
                        d="M65 205 L335 198 L285 260 L125 260 Z"
                        fill="url(#wood)"
                        stroke="#42271b"
                        strokeWidth="4"
                    />

                    {/* 나무 결 */}
                    <path
                        d="M105 220 L310 216 M120 235 L298 232 M140 248 L285 247"
                        stroke="#d19a68"
                        strokeWidth="3"
                        opacity=".7"
                    />

                    {/* 창문 */}
                    <circle cx="165" cy="220" r="7" fill="#f9d98b"/>
                    <circle cx="200" cy="220" r="7" fill="#f9d98b"/>
                    <circle cx="235" cy="219" r="7" fill="#f9d98b"/>
                </svg>
            </div>

            {/* 뒷부분 파도 */}
            <svg
                style={{
                    position: "absolute",
                    zIndex: 2,
                    bottom: "75px",
                    left: "-50%",
                    width: "200%",
                    height: "150px",
                    animation: "waveOne 8s ease-in-out infinite",
                    pointerEvents: "none"
                }}
                viewBox="0 0 1440 200"
                preserveAspectRatio="none"
            >
                <path
                    d="M0 90 Q180 20 360 90 T720 90 T1080 90 T1440 90 L1440 200 L0 200Z"
                    fill="#168fc3"
                />
            </svg>

            {/* 앞부분 파도 */}
            <svg
                style={{
                    position: "absolute",
                    zIndex: 6,
                    bottom: 0,
                    left: "-50%",
                    width: "200%",
                    height: "180px",
                    animation: "waveTwo 9s ease-in-out infinite",
                    pointerEvents: "none"
                }}
                viewBox="0 0 1440 200"
                preserveAspectRatio="none"
            >
                <path
                    d="M0 65 Q180 130 360 65 T720 65 T1080 65 T1440 65 L1440 200 L0 200Z"
                    fill="#00669e"
                />

                <path
                    d="M0 85 Q180 145 360 85 T720 85 T1080 85 T1440 85"
                    fill="none"
                    stroke="#9ceaff"
                    strokeWidth="5"
                    opacity=".7"
                />
            </svg>

            {/* 물보라 */}
            {[8, 20, 75, 88].map((x, i) => (
                <div
                    key={i}
                    style={{
                        position: "absolute",
                        zIndex: 7,
                        left: `${x}%`,
                        bottom: `${90 + (i % 2) * 20}px`,
                        width: "45px",
                        height: "7px",
                        borderRadius: "50%",
                        background: "#d8f8ff",
                        filter: "blur(2px)",
                        animation: `foam ${1.5 + i * .3}s ease-in-out infinite alternate`,
                        pointerEvents: "none"
                    }}
                />
            ))}

            {/* 반짝이는 물결 */}
            {[15, 30, 48, 68, 83, 92].map((x, i) => (
                <div
                    key={i}
                    style={{
                        position: "absolute",
                        zIndex: 8,
                        left: `${x}%`,
                        bottom: `${20 + (i % 3) * 35}px`,
                        width: "5px",
                        height: "5px",
                        borderRadius: "50%",
                        background: "#fff",
                        boxShadow: "0 0 12px #fff",
                        animation: `sparkle ${1 + i * .3}s infinite`,
                        pointerEvents: "none"
                    }}
                />
            ))}

            {/* 하단 문구 */}
            <div style={{
                position: "absolute",
                bottom: "18px",
                zIndex: 10,
                width: "100%",
                textAlign: "center",
                color: "#e4f8ff",
                fontSize: "13px",
                fontWeight: 600,
                letterSpacing: "2px",
                textShadow: "0 2px 5px #003b70"
            }}>
                FOLLOW YOUR OWN HORIZON
            </div>

        </div>
    );
};

export default BoatOnOcean;
